export default "/images/vendor/flag-icons/flags/4x3/ag.svg?8564c0e53486b9319587a31cb2f1b34b";